import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../html/element'
import { selectChartData } from '../store'

const TooltipContent = (props) => {
  const { active, payload, label, schema, chartId, maxWidth } = props
  const data = payload && payload.length > 0 ? payload[0].payload : {}

  const { activeKey, activeTooltip } = useSelector(selectChartData(chartId))

  if (!active || (chartId && !activeTooltip)) return null

  const renderTooltipLabel = () => {
    if (schema.title?.hide) return null

    return (
      <div className="fstItalic mb1">
        {schema.title?.formatter ? schema.title.formatter(label, props) : label}
      </div>
    )
  }

  const renderTooltipContent = () => {
    return schema.content.map((item, index) => {
      const {
        dataKey,
        label: labelItem,
        isI18n,
        formatLabel,
        formatValue,
        formatValueColor,
        unit,
        isHidden = false,
      } = item

      if (typeof isHidden === 'function' ? isHidden(data) : isHidden)
        return null

      const newLabel = labelItem || label

      const labelFormatted = formatLabel
        ? formatLabel(newLabel, props)
        : newLabel

      if (chartId && dataKey !== activeKey) return null

      return (
        <div key={index} className="dFlex justifyContentBetween gap4">
          <div>
            {isI18n ? <Translate value={labelFormatted} /> : labelFormatted}
          </div>
          <div>
            <span
              className="fw500"
              style={{
                whiteSpace: 'nowrap',
                color: formatValueColor && formatValueColor(data[dataKey]),
              }}
            >
              {formatValue ? formatValue(data[dataKey]) : data[dataKey]}
              {unit && <> {unit}</>}
            </span>
          </div>
        </div>
      )
    })
  }

  return (
    <Element
      elementName="div"
      className="p1"
      style={{
        backgroundColor: '#000000',
        opacity: 0.7,
        color: '#FFFFFF',
        maxWidth,
      }}
    >
      {schema.renderCustomContent ? (
        schema.renderCustomContent({ data, renderTooltipLabel })
      ) : (
        <>
          {renderTooltipLabel()}
          {renderTooltipContent()}
        </>
      )}
    </Element>
  )
}

TooltipContent.propTypes = {
  chartId: PropTypes.string,
  schema: PropTypes.object.isRequired,
  // All rechart tooltip content props
}

export default TooltipContent
